<div class="summary-details">
  <div class="text-label">{{ label }}</div>
  <div class="text-data {{textCss}}">{{ text | summary : placeholder : prefix : suffix }}</div>
  <div>{{ addtionalText }}</div>
</div>
